import { render } from "./ticket-data.vue?vue&type=template&id=37c016d0"
import script from "./ticket-data.vue?vue&type=script&lang=js"
export * from "./ticket-data.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__